import * as z from "zod";

const createEnv = () => {
  // Path-only on the server, where api-client prefixes this request's loopback origin.
  const origin = globalThis.location ? `${globalThis.location.protocol}//${globalThis.location.host}` : "";
  const EnvSchema = z.object({
    AUTH_API_URL: z.string(),
    API_URL_V2: z.string(),
    API_URL_DOCS: z.string(),
    API_URL_CATALOG: z.string(),
    VIANEXUS_API_URL: z.string(),
    API_URL_WEB: z.string(),
    ADMIN_API_URL: z.string(),
  });

  const parsedEnv = EnvSchema.safeParse({
    AUTH_API_URL: `${origin}/auth/api`,
    API_URL_V2: `${origin}/console/api`,
    API_URL_DOCS: `${origin}/docs`,
    API_URL_CATALOG: `${origin}/catalog/api`,
    VIANEXUS_API_URL: `${origin}/api`,
    API_URL_WEB: `${origin}/web`,
    ADMIN_API_URL: `${origin}/admin/api`,
  });

  if (!parsedEnv.success) {
    throw new Error(
      `Invalid env provided.
The following variables are missing or invalid:
${Object.entries(parsedEnv.error.flatten().fieldErrors)
  .map(([k, v]) => `- ${k}: ${v}`)
  .join("\n")}
`
    );
  }

  return parsedEnv.data;
};

export const env = createEnv();
